import { render, staticRenderFns } from "./footer-basic.vue?vue&type=template&id=8b9e0f90"
import script from "./footer-basic.vue?vue&type=script&lang=js"
export * from "./footer-basic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports